import { useState } from 'react';

import Color from 'color';
import {
  Button as MuiButton,
  Menu as MuiMenu,
  MenuItem as MuiMenuItem,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';
import { onAccountSwitchRequested } from '../../../utils';
import { usePersona } from '../../../components/hooks/usePersona';
import { withShowable } from '../lib/withShowable';

export const AccountsMenu = withShowable(
  // @ts-expect-error TS(2339): Property 'isGhosting' does not exist on type '{}'.
  ({ isGhosting = false, userColors, accounts = [] }) => {
    const persona = usePersona();

    const classes = useMenuStyles({
      isGhosting,
      userColor: isGhosting
        ? userColors[persona] || 'transparent'
        : 'transparent',
    });
    const [anchor, setAnchor] = useState(null);

    const handleClick = (event: any) => {
      setAnchor(event.currentTarget);
    };

    const handleClose = () => {
      setAnchor(null);
    };

    return (
      <>
        <div className={classes.logoActions}>
          <MuiButton
            onClick={handleClick}
            className={classes.button}
            variant="contained"
            disableElevation
            disableRipple
            aria-label="Switch accounts"
          >
            Switch accounts <KeyboardArrowDownIcon />
          </MuiButton>
        </div>
        <MuiMenu
          classes={{ paper: classes.menuPaper }}
          anchorEl={anchor}
          open={Boolean(anchor)}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          {accounts.map((value: any) => {
            return (
              <MuiMenuItem
                key={value.accountId}
                className="tertia-text"
                onClick={onAccountSwitchRequested(
                  value.accountType,
                  value.accountId,
                  value.accountName
                )}
              >
                {value.accountName}
              </MuiMenuItem>
            );
          })}
        </MuiMenu>
      </>
    );
  }
);

const useMenuStyles = makeStyles(({ palette, config }) => ({
  menuPaper: {
    marginTop: '1rem',
    background: palette.background.paper,
  },

  logoActions: {
    left: '2.8rem',
    paddingLeft: '1.5rem',
  },

  menuHeader: {
    paddingRight: '1.1666666667rem',
    paddingLeft: '1.1666666667rem',
    marginTop: '0.6666666667rem',
    marginBottom: '0.8333333333rem',
  },

  button: {
    padding: '0 0.3333333333rem 0 0.6666666667rem',
    // @ts-expect-error TS(2339): Property 'userColor' does not exist on type '{}'.
    backgroundColor: (props) => props.userColor,
    color: (props) => {
      // @ts-expect-error TS(2339): Property 'isGhosting' does not exist on type '{}'.
      if (!props.isGhosting) {
        return palette.text.secondary;
      }

      return palette.primary.main;
    },
    fontSize: config.textSizes.normal,
    fontFamily: config.fonts.stackSans,

    '&:hover, &:focus': {
      backgroundColor: (props) =>
        // @ts-expect-error TS(2339): Property 'userColor' does not exist on type '{}'.
        props.userColor !== 'transparent'
          ? // @ts-expect-error TS(2339): Property 'userColor' does not exist on type '{}'.
            Color(props.userColor).darken(0.25).hex()
          : 'transparent',
    },
  },
}));
